module.exports = __webpack_public_path__ + "static/media/updatestone.ae197ecc.svg";